'use client';

import { c as _c } from "react/compiler-runtime";
import { TextButton } from '@/shared/ui/atoms';
import useHomeUIStore from '@/features/home/model/ui/store';
import { useTranslations } from 'next-intl';
const TreatmentCaseListFilter = () => {
  const $ = _c(37);
  const t = useTranslations();
  const {
    selectedTreatmentTab,
    setSelectedTreatmentTab
  } = useHomeUIStore();
  let t0;
  if ($[0] !== t) {
    t0 = t("commonSearch.filter.all");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = `${"py-2 px-[14px] text-[15px] line-height-[22px] font-medium bg-gray-100 rounded-full"} ${selectedTreatmentTab === 0 ? "bg-gray-700 text-white" : "bg-gray-100 text-gray-900"}`;
  let t2;
  if ($[2] !== setSelectedTreatmentTab) {
    t2 = () => setSelectedTreatmentTab(0);
    $[2] = setSelectedTreatmentTab;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = <TextButton text={t0} className={t1} onClick={t2} />;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("commonMedicalTreatment.treatments.dentistry");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `${"py-2 px-[14px] text-[15px] line-height-[22px] font-medium bg-gray-100 rounded-full"} ${selectedTreatmentTab === 4 ? "bg-gray-700 text-white" : "bg-gray-100 text-gray-900"}`;
  let t6;
  if ($[10] !== setSelectedTreatmentTab) {
    t6 = () => setSelectedTreatmentTab(4);
    $[10] = setSelectedTreatmentTab;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <TextButton text={t4} className={t5} onClick={t6} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("commonMedicalTreatment.treatments.dermatology");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = `${"py-2 px-[14px] text-[15px] line-height-[22px] font-medium bg-gray-100 rounded-full"} ${selectedTreatmentTab === 2 ? "bg-gray-700 text-white" : "bg-gray-100 text-gray-900"}`;
  let t10;
  if ($[18] !== setSelectedTreatmentTab) {
    t10 = () => setSelectedTreatmentTab(2);
    $[18] = setSelectedTreatmentTab;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8 || $[22] !== t9) {
    t11 = <TextButton text={t8} className={t9} onClick={t10} />;
    $[20] = t10;
    $[21] = t8;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("commonMedicalTreatment.treatments.plasticSurgery");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = `${"py-2 px-[14px] text-[15px] line-height-[22px] font-medium bg-gray-100 rounded-full"} ${selectedTreatmentTab === 1 ? "bg-gray-700 text-white" : "bg-gray-100 text-gray-900"}`;
  let t14;
  if ($[26] !== setSelectedTreatmentTab) {
    t14 = () => setSelectedTreatmentTab(1);
    $[26] = setSelectedTreatmentTab;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14) {
    t15 = <TextButton text={t12} className={t13} onClick={t14} />;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t11 || $[33] !== t15 || $[34] !== t3 || $[35] !== t7) {
    t16 = <div className="flex items-center gap-[6px] py-2.5 whitespace-nowrap overflow-x-auto scrollbar-hide">{t3}{t7}{t11}{t15}</div>;
    $[32] = t11;
    $[33] = t15;
    $[34] = t3;
    $[35] = t7;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
export default TreatmentCaseListFilter;